import pb from '../lib/pocketbase';

// Obtener lista de usuarios con paginación
export async function getUsers(page, perPage) {
  return await pb.collection('users').getList(page, perPage, {
    sort: '-created',
    expand: ['role'], // Expande la relación con roles
    $autoCancel: false, // Desactiva la auto-cancelación de peticiones
  });
}

// Crear un nuevo usuario
export async function createUser(user) {
  return await pb.collection('users').create(user);
}

// Actualizar un usuario existente
export async function updateUser(id, user) {
  return await pb.collection('users').update(id, user);
}

// Eliminar un usuario por su ID
export async function deleteUser(id) {
  return await pb.collection('users').delete(id);
}